<template>
  <b-modal
      ref="modal"
      :active="active"
      class="card-form-modal ask"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      :custom-class="'dialog mpc'"
      scroll="keep"
      aria-modal
      @close="cancel">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Ask a Question</p>
        <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
      </header>
      <section class="modal-card-body">
        <p>If you have any question you can ask below and we will send the
          answer to your email: {{ email }}</p>
        <form>
              <b-input name="question" id="question" class="textarea-question"
                       type="textarea" rows="8" v-model="question"
                       placeholder="Short description of your request"
                       ref="quest"></b-input>
        </form>
      </section>
      <footer class="modal-card-foot buttons is-right">
          <button class="button"
                  type="button" @click="cancel">CANCEL</button>
          <button class="button is-success" :disabled="!(!!question)"
                  :loading="emailSending"
                  @click="submit">SEND</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'AskQuestion',
  props: {
    emailSending: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    email: null,
  },
  data() {
    return {
      question: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('focus', this.$refs.quest);
    });
  },
  methods: {
    submit() {
      this.$emit('submit', this.question);
      this.question = null;
      this.$emit('close');
    },
    cancel() {
      this.question = null;
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="stylus">
.dialog .modal-card .modal-card-body .field
   margin-top 0
 .mpc.ask
  >>> .animation-content
    max-width none !important
    width 736px
    .modal-close
      display none
      &.active
         display block
         position absolute!important
         top 20px
         transform translateY(-50%)
         border none
         right 5px
      &:before,
      &:after
       background-color #000
    @media(max-width:1235px)
      width 600px
    @media(max-width:750px)
      width calc(100% - 10px)
.dialog .modal-card
    width 100%
    max-width 100%
    max-height 75vh
    height fit-content
    border-radius 0 0 6px 6px
    position relative
    font-family Fira Sans
.dialog .modal-card .modal-card-head
    position relative
    padding 30px 40px
    @media(max-width:750px)
      padding 20px 25px
    p
      text-align left
      font-size 30px
      line-height 25px
      @media(max-width:1023px)
        font-size 26px
      @media(max-width:750px)
        font-size 20px
      @media(max-width:630px)
        text-align center
.dialog .modal-card .modal-card-body
    padding 20px 40px 20px
    max-height 800px
    @media(max-width:750px)
      padding 20px 25px 20px
    p
     margin-bottom 20px
     font-size 20px
     line-height 28px
     color #293033
     text-align left
     @media(max-width:1023px)
      font-size 18px
      line-height 24px
     @media(max-width:750px)
       font-size 16px
       line-height 22px
     @media(max-width:630px)
       text-align center
.dialog .modal-card .modal-card-body .textarea-question textarea.textarea
     word-break break-all
     padding 20px 25px
     font-size 20px
     line-height 28px
     &:placeholder
       color #8A9499
       font-size 20px
       line-height 28px
.dialog .modal-card .modal-card-foot .button
    font-weight 500
    width 180px
    height 60px
    font-size 22px
    line-height 24px
    border 1px solid #68BA62
    border-radius 3px
    color #68BA62
    font-family Fira Sans
    &:hover
      background #17B548
      border 1px solid #17B548
      color #fff
    @media(max-width:750px)
      font-size 20px
      height 48px
    @media(max-width:630px)
      width 100%
      height 45px
.dialog .modal-card .modal-card-foot .button.is-success
    border 1px solid #68BA62
    background #68BA62
    color #fff
    &:hover
     background #17B548
     border 1px solid #17B548
.dialog .modal-card .modal-card-foot .button[disabled]
     background-color #b8c5cd !important
     border-color #dbdbdb
     opacity 0.5
     &:hover
       background-color #b8c5cd !important
       border-color #dbdbdb
.dialog .modal-card .modal-card-foot
   background-color #fff
   border 0px #ffffff solid
   border-radius 0 0 6px 6px
   padding 5px 40px 30px
   @media(max-width:750px)
    padding 5px 25px 25px
</style>
